module.exports = __webpack_public_path__ + "static/media/DSC_0046.8a506d79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0046.jpg
// module id = 681
// module chunks = 0